// Teacher portal — resolved at runtime
export const TEACHER_LOGIN     = (slug: string) => `/${slug}/login`;
export const TEACHER_DASHBOARD = (slug: string) => `/${slug}/dashboard`;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  ADMIN_LOGIN: '/admin-login',
  ADMIN_DASHBOARD: '/admin-dashboard',
  DASHBOARD: '/dashboard',
  ALLOW_CAMERA: '/allow-camera',
  RAN_TEST: '/ran-test',
  CALIBRATION: '/calibration',
  STORY: '/story',
  STORY1: '/story1',
  STORY2: '/story2',
  STORY1_QUESTIONS: '/story1-questions',
  STORY1_QUESTIONS2: '/story1-questions2',
  STORY2_QUESTIONS: '/story2-questions',
  STORY2_QUESTIONS2: '/story2-questions2',
  WORD_WRITING: '/word-writing',
  FINISH: '/finish',
  RESUME: '/resume/:assessmentId',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

const ASSESSMENT_FLOW_PATHS = new Set<string>([
  ROUTES.ALLOW_CAMERA,
  ROUTES.CALIBRATION,
  ROUTES.RAN_TEST,
  ROUTES.STORY,
  ROUTES.STORY1,
  ROUTES.STORY1_QUESTIONS,
  ROUTES.STORY1_QUESTIONS2,
  ROUTES.STORY2,
  ROUTES.STORY2_QUESTIONS,
  ROUTES.STORY2_QUESTIONS2,
  ROUTES.WORD_WRITING,
  ROUTES.FINISH,
]);

/**
 * Returns true only for routes that require desktop assessment hardware.
 * Public pages, authentication, dashboards, and white-label portals remain
 * available on phones and tablets.
 */
export function isAssessmentFlowPath(pathname: string): boolean {
  const normalizedPath = pathname.length > 1
    ? pathname.replace(/\/+$/, '')
    : pathname;

  // /resume/:assessmentId is part of the assessment flow — needs desktop + webcam
  if (normalizedPath.startsWith('/resume/')) return true;

  return ASSESSMENT_FLOW_PATHS.has(normalizedPath);
}
